;(function ($) {
	"use strict";

	require('./plugins/morrisjs/morris.min');
	
	window.Dashboard = function (options) {
		this._init(options);
	};

	$.extend(Dashboard.prototype, {
		$options: {
			private: {
			}
		},

		//=====================================================================
		// Dashboard init section
		//=====================================================================

		/**
		 * initialize graphs
:		 */
		init: function () {
			this.loadData();
		},
		
		//=====================================================================
		// Methods section
		//=====================================================================
		
		loadData: function () {
			var app = this,
				$shiftsContent = $('#graph-shifts'),
				url = $shiftsContent.data('url'),
				dateFrom = $('#dashboard-stats-from').val(),
				dateTo = $('#dashboard-stats-to').val();

			$.ajax({
				type: 'POST',
				url: url,
				data: {
					from : dateFrom,
					to : dateTo,
				},
				success: function (result) {
					$.each(result, function (i, shift) {
						var $table = $('#graph-shift-tab-' + shift.id);
						if ('stats' in shift) {
							$.each(shift.stats, function (j, stat) {
								var $row = $table.find('tr.stat-row.st-' + stat.wd_state);
								if ($row.length > 0) {
									for (var prop in stat) {
										switch (prop) {
											case 'wd_ids':
											case 'wd_state':
											case 'wd_type':
												break;
											default:
												var val = (stat[prop]) ? parseInt(stat[prop]) : 0;
												$row.find('td.stat-col-'+stat.wd_type+'-'+prop).text(val);
												break;
										}
									}
								}
							});
						}
						app.fillTotals($table);
					});
				},
				error: function(error) {
					console.error(error);
				},
				timeout: 2000,
			});
		},

		fillTotals: function ($table) {
			var $rows = $table.find('tr.stat-row'),
				totals = {
				'stat-col-1-wd_count': 0,
				'stat-col-1-wd_price': 0,
				'stat-col-1-wd_tpzov': 0,
				'stat-col-1-wd_bonus': 0,
				'stat-col-2-wd_count': 0,
				'stat-col-2-wd_price': 0,
				'stat-col-count_total': 0,
				'stat-col-price_total': 0,
				'stat-col-total_total': 0,
				};
			$rows.each(function (i, row) {
				var $row = $(row),
					cnt1 = parseInt($row.find('.stat-col-1-wd_count').text()),
					cnt2 = parseInt($row.find('.stat-col-2-wd_count').text()),
					price1 = parseInt($row.find('.stat-col-1-wd_price').text()),
					price2 = parseInt($row.find('.stat-col-2-wd_price').text()),
					bonus1 = parseInt($row.find('.stat-col-1-wd_tpzov').text()),
					bonus2 = parseInt($row.find('.stat-col-1-wd_bonus').text()),
					cntTot = cnt1 + cnt2,
					priceTot = price1 + price2,
					total = priceTot + bonus1 + bonus2;
					
				$row.find('.stat-col-count_total').text(cntTot);
				$row.find('.stat-col-price_total').text(priceTot);
				$row.find('.stat-col-total_total').text(total);
				totals['stat-col-1-wd_count'] += cnt1;
				totals['stat-col-1-wd_price'] += price1;
				totals['stat-col-1-wd_tpzov'] += bonus1;
				totals['stat-col-1-wd_bonus'] += bonus2;
				totals['stat-col-2-wd_count'] += cnt2;
				totals['stat-col-2-wd_price'] += price2;
				totals['stat-col-count_total'] += cntTot;
				totals['stat-col-price_total'] += priceTot;
				totals['stat-col-total_total'] += total;
			});
			var $footerRow = $table.find('tr.stat-footer');
			$.each(totals, function (key, val) {
				$footerRow.find('th.'+key).text(val);
			});
		},
		
		//=====================================================================
		// Controls section
		//=====================================================================

		/**
		 * HANDLE BUTTONS
		 */
		handleButtons: function() {
			var app = this,
				$document = $(document);

			$document.on('click', '#dashboard-stats-reload', function (e) {
				e.preventDefault(); //zamezeni defaultniho chování akce, neodesle se formular. Kontrola formuláře před odesláním na server
				app.loadData();
			});
			
		},

		_init: function (options) {
			this.$options = $.extend({}, this.$options, options || {});

            this.init();
			this.handleButtons();
		},
	});

})(jQuery);

